import type { IAddress } from '@/interfaces/IAddress'
import type { IUserCreate } from '@/interfaces/users/IUserCreate'
import type { IUserNextOfKinDetail } from '@/interfaces/users/IUserNextOfKinDetail'
import Address from '../Address'
import NextOfKinDetail from '../NextOfKinDetail'

class UserCreate implements IUserCreate {
  name: string
  
  role: string

  email?: string

  phoneNumber?: string

  designation?: string

  teamTitle?: string

  employeeCode?: string

  alternatePhoneNumber?: string

  dateOfBirth?: string

  nextOfKinDetail: IUserNextOfKinDetail

  address: IAddress

  constructor(user?: any) {
    this.name = user?.name ?? null
    this.role = user?.role ?? null
    this.email = user?.email ?? null
    this.phoneNumber = user?.phoneNumber ?? null
    this.designation = user?.designation ?? null
    this.teamTitle = user?.teamTitle ?? null
    this.employeeCode = user?.employeeCode ?? null
    this.alternatePhoneNumber = user?.alternatePhoneNumber ?? null
    this.dateOfBirth = user?.dateOfBirth ?? null
    this.nextOfKinDetail = new NextOfKinDetail(user?.nextOfKinDetail)
    this.address = new Address(user?.address)
  }
}

export default UserCreate
